<template lang="pug">
//- Content-type badge shared by Thinking / Dialogues / search hits. Label from i18n thinking.types.*
span.type-badge(:class="'type-' + type") {{ $t('thinking.types.' + type) }}
</template>

<script>
export default {
  name: 'TypeBadge',
  props: { type: { type: String, required: true } },
}
</script>
